import { render, staticRenderFns } from "./BotaoProtecaoDados.vue?vue&type=template&id=ac5b3dae&scoped=true&"
import script from "./BotaoProtecaoDados.vue?vue&type=script&lang=js&"
export * from "./BotaoProtecaoDados.vue?vue&type=script&lang=js&"
import style0 from "./BotaoProtecaoDados.vue?vue&type=style&index=0&id=ac5b3dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5b3dae",
  null
  
)

export default component.exports